export const sortTreatmentByLatest = (treatments) => {
  const sortByDate = (a, b) => new Date(b.date_of_adding) - new Date(a.date_of_adding);
  const sortByIsLatest = (a, b) => (b.isLatest ? 1 : 0) - (a.isLatest ? 1 : 0);

  return [...treatments]
    .sort(sortByDate)
    .sort(sortByIsLatest);
};
